import SetUsersLocation from "../Component/FindTutors/SetUsersLocation";
import AccountSettings from "../Pages/Account/AccountSettings";
//import StudentAccount from "../Pages/Account/StudentAccount";
//import TutorAccount from "../Pages/Account/TutorAccount";
import AllUsers from "../Pages/AllUsers";
import ConversationContain from "../Pages/Chat/ChatApp/Conversation";
import InboxContain from "../Pages/Chat/ChatApp/Inbox";
import Default from "../Pages/DashBoard/Default/Default";
import FAQ from "../Pages/FAQ";
import FindStudents from "../Pages/FindStudents";
import FindTutors from "../Pages/FindTutors";
import StudentNewAccount from "../Pages/NewAccount/StudentAccount";
import TutorNewAccount from "../Pages/NewAccount/TutorAccount";
import NewStudentTuitions from "../Pages/NewMyTuitions/Student";
import NewTutorTuitions from "../Pages/NewMyTuitions/Tutor";
import RequestTuition from "../Pages/RequestTuition";
import StudentProfile from "../Pages/StudentProfile";
import TutorProfile from "../Pages/TutorProfile";
import OnDemandTuitionRequest from "../Pages/OnDemandTuitionRequest";
import TutorClassSchedule from "../Pages/Schedule/Tutor";
import StudentClassSchedule from "../Pages/Schedule/Student";

export const routes = [
  {
    path: `${process.env.PUBLIC_URL}`,
    Component: <Default />,
  },
  {
    path: `${process.env.PUBLIC_URL}/`,
    Component: <Default />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard`,
    Component: <Default />,
  },
  { path: `${process.env.PUBLIC_URL}/find-tutors`, Component: <FindTutors /> },
  {
    path: `${process.env.PUBLIC_URL}/find-students`,
    Component: <FindStudents />,
  },
  {
    path: `${process.env.PUBLIC_URL}/set-location`,
    Component: <SetUsersLocation />,
  },
  {
    path: `${process.env.PUBLIC_URL}/request-tuition`,
    Component: <RequestTuition />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tutor-account`,
    Component: <TutorNewAccount />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/tutor-new-account`,
  //   Component: <TutorNewAccount />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/student-new-account`,
  //   Component: <StudentNewAccount />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/student-account`,
    Component: <StudentNewAccount />,
  },
  {
    path: `${process.env.PUBLIC_URL}/profile/:id`,
    Component: <TutorProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tutor-tuitions`,
    Component: <NewTutorTuitions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/student-tuitions`,
    Component: <NewStudentTuitions />,
  },
  {
    path: `${process.env.PUBLIC_URL}/student-profile/:id`,
    Component: <StudentProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/member-list`,
    Component: <AllUsers />,
  },
  {
    path: `${process.env.PUBLIC_URL}/inbox`,
    Component: <ConversationContain />,
  },
  {
    path: `${process.env.PUBLIC_URL}/inbox/:id`,
    Component: <InboxContain />,
  },
  {
    path: `${process.env.PUBLIC_URL}/settings`,
    Component: <AccountSettings />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/settings/personalInfo`,
  //   Component: <PersonalAccountSettings />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/settings/security-privacy`,
  //   Component: <SecurityAndPrivacySettings />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/tutors-request`,
    Component: <OnDemandTuitionRequest />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tutor-class-schedule`,
    Component: <TutorClassSchedule />,
  },
  {
    path: `${process.env.PUBLIC_URL}/student-class-schedule`,
    Component: <StudentClassSchedule />,
  },
  {
    path: `${process.env.PUBLIC_URL}/faq/`,
    Component: <FAQ />,
  },
];
